import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";



const PayrollOverview = () => {
const data = [
    { month: "Jan", amount: 312000 },
    { month: "Feb", amount: 305000 },
    { month: "Mar", amount: 295000 },
    { month: "Apr", amount: 298000 },
    { month: "May", amount: 285000 },
    { month: "Jun", amount: 285000 },
];

  return (
    <HeaderComponent
      title="Payroll Overview"
      description="Monthly payroll expenses"
    >
      <BarChartBase
        data={data}
        xKey="month"
        height={300}
        yKey="amount"
        useGradient={true}
        textSize={14}
      />
   </HeaderComponent>
  );
};

export default PayrollOverview;
